module.exports = {
    "baseUrl": "https://api-v4.staging.primrose.health",
    "systemName": "System dev",
    "chatServer": "https://staging.trillium.health:8082/chatWebsocket",
    "newChatServer": "https://api-v4.chat.staging.primrose.health",
    "companyTitle": "Patient Chat | Trillium Health",
    "metaTitle": "Trillium Health Chat",
    "favicon": "%PUBLIC_URL%/favicon.png",
    "redirectUrl": "https://tensaw.health/",
    "companyName": "Trillium Technologies",
    "copyRight": "Primrose Health and Trillium Technologies are trademarks of their respective owners.",
    "companyKey": "trillium"
}